import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const SourcesOfIncomeSection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="sourcesOfIncomeSection"
      title={t('client.client.sourcesOfIncome.title')}
    >
      <FormContent {...formProps} />
    </Section>
  );
};
